const API = process.env.REACT_APP_BACKEND_URL;

const initials = (name) => (name || "?").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toLocaleUpperCase("tr");

export const UserAvatar = ({ user, size = "h-8 w-8", text = "text-xs" }) =>
  user?.avatar ? (
    <img src={`${API}/api/profile/avatar?v=${user.avatar}`} alt="profil" data-testid="user-avatar-img"
      className={`${size} rounded-full object-cover shrink-0`} />
  ) : (
    <span data-testid="user-avatar-initials"
      className={`${size} ${text} rounded-full bg-emerald-100 text-emerald-800 font-semibold flex items-center justify-center shrink-0`}>
      {initials(user?.name)}
    </span>
  );
